"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getPersonaByEmail_1 = require("./../../util/getPersonaByEmail");
var synchronizeSearchFolder_1 = require("./synchronizeSearchFolder");
var datapoints_1 = require("../../datapoints");
var owa_analytics_1 = require("owa-analytics");
var owa_guid_1 = require("owa-guid");
var store_1 = require("../../store/store");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var owa_trace_1 = require("owa-trace");
var legacy_1 = require("satcheljs/lib/legacy");
var createDropViewState_1 = require("owa-dnd/lib/utils/createDropViewState");
/**
 * Add a favorite node to the favorite store
 */
var addFavoritePersonaAction = legacy_1.action('AddFavoritePersona', datapoints_1.default.AddFavoritePersonaAction)(function addFavoritePersona(emailAddress, displayName, personaId, actionSource, isRetry) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritesStore, tempPersonaId, initialFavoritePersona, persona, personaIdForEmail_1, favoritePersonaUpdated, index, selectedPersonaNode, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    favoritesStore = store_1.getStore();
                    favoritesStore.isFavoritePersonasChangeable = false;
                    tempPersonaId = personaId ? personaId : owa_guid_1.getGuid();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        throw new Error('Cannot add duplicate personas to favorites. Store has tempId before Persona resolution');
                    }
                    initialFavoritePersona = {
                        id: tempPersonaId,
                        type: 1 /* Persona */,
                        displayName: displayName,
                        mainEmailAddress: emailAddress,
                        allEmailAddresses: [],
                        searchFolderId: undefined,
                        isJustAdded: true,
                        isSyncUpdateDone: true,
                        dropViewState: createDropViewState_1.default(),
                    };
                    // Add to favorite to favorites store, to update the UI with the initial information
                    favoritesStore.orderedFavoritesNodeIds.push(tempPersonaId);
                    favoritesStore.favoritesPersonaNodes.set(tempPersonaId, initialFavoritePersona);
                    return [4 /*yield*/, getPersonaByEmail_1.default(emailAddress, displayName).catch(function (error) {
                            cleanup(tempPersonaId);
                            throw error;
                        })];
                case 2:
                    persona = _b.sent();
                    // Between the add and await the user can potentially have removed the entry
                    if (!favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        favoritesStore.isFavoritePersonasChangeable = true;
                        return [2 /*return*/];
                    }
                    personaIdForEmail_1 = persona.PersonaId.Id;
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (tempPersonaId !== personaIdForEmail_1 &&
                        favoritesStore.favoritesPersonaNodes.has(personaIdForEmail_1)) {
                        cleanup(tempPersonaId);
                        throw new Error('Cannot add duplicate personas to favorites. Store has personaId after Persona resolution.');
                    }
                    favoritePersonaUpdated = tslib_1.__assign({}, initialFavoritePersona, { id: personaIdForEmail_1, displayName: persona.DisplayName, mainEmailAddress: persona.EmailAddress.EmailAddress, allEmailAddresses: persona.EmailAddresses.map(function (email) { return email.EmailAddress; }), isJustAdded: false });
                    // Add to favorite to favorites store
                    favoritesStore.favoritesPersonaNodes.set(personaIdForEmail_1, favoritePersonaUpdated);
                    // Remove the temp node in case the given the personaId in the parameter was undefined
                    if (tempPersonaId !== personaIdForEmail_1) {
                        favoritesStore.favoritesPersonaNodes.delete(tempPersonaId);
                        index = favoritesStore.orderedFavoritesNodeIds.indexOf(tempPersonaId);
                        if (index > -1) {
                            favoritesStore.orderedFavoritesNodeIds[index] = personaIdForEmail_1;
                        }
                    }
                    selectedPersonaNode = owa_mail_folder_forest_store_1.getSelectedNode();
                    if (selectedPersonaNode.id === personaIdForEmail_1 &&
                        selectedPersonaNode.markedForDeletion) {
                        // A person might be favorited before the search folder is deleted
                        // Remove the markedForDeletion flag
                        selectedPersonaNode.markedForDeletion = false;
                    }
                    // Setup search folder
                    return [4 /*yield*/, synchronizeSearchFolder_1.default(favoritePersonaUpdated).catch(function (error) {
                            cleanup(personaIdForEmail_1);
                            throw error;
                        })];
                case 3:
                    // Setup search folder
                    _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    _a = datapoints_1.default.AddFavoritePersonaFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    if (isRetry) {
                        // This will log error as well
                        owa_trace_1.trace.error({ message: eventName, error: error_1 });
                    }
                    else {
                        owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    }
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString(), isRetry));
                    throw tslib_1.__assign({ type: 'AddFavoritePersonaError' }, error_1);
                case 5: return [2 /*return*/];
            }
        });
    });
});
function cleanup(personaId) {
    var favoritesStore = store_1.getStore();
    var index = favoritesStore.orderedFavoritesNodeIds.indexOf(personaId);
    if (index > -1) {
        favoritesStore.orderedFavoritesNodeIds.splice(index, 1);
    }
    if (favoritesStore.favoritesPersonaNodes.has(personaId)) {
        favoritesStore.favoritesPersonaNodes.delete(personaId);
    }
}
exports.default = addFavoritePersonaAction;
//# sourceMappingURL=addFavoritePersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/addFavoritePersona.js
// module id = 3335
// module chunks = 14 68